import { defaultCountries } from 'react-international-phone';
export const COUNTRY_CODE_US = 'us';
export const translateCountryNames = (countries, locale) => {
    const countryTranslator = new Intl.DisplayNames([locale], {
        type: 'region',
    });
    return countries.map(([countryName, countryIsoCode2, ...otherCountryInfo]) => {
        let translatedCountryName = countryName;
        try {
            translatedCountryName = countryTranslator.of(countryIsoCode2.toUpperCase()) || translatedCountryName;
        }
        catch (_a) {
        }
        return [translatedCountryName, countryIsoCode2, ...otherCountryInfo];
    });
};
export const getPreferredCountries = (countries, iso2CodesToKeep) => {
    const countriesHashMap = Object.fromEntries(countries.map((country) => [country[1], country]));
    return iso2CodesToKeep.map((countryIso2) => countriesHashMap[countryIso2]);
};
const removeCountriesIncludedInIso2List = (country, iso2Codes) => {
    const iso2 = country[1];
    return !iso2Codes.includes(iso2);
};
export const getNonPreferredCountries = (countries, preferredCountriesIso2, locale) => countries
    .filter((country) => removeCountriesIncludedInIso2List(country, preferredCountriesIso2))
    .sort(([countryNameA], [countryNameB]) => countryNameA.localeCompare(countryNameB, locale));
export const findCountryByIso = (countryIso) => defaultCountries.find((country) => country[1] === countryIso);
